// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"promote_tableWrap_28hla","linkButton":"promote_linkButton_1T9IG","scoreIcon":"promote_scoreIcon_28Ruy"};